// @flow

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Grid } from 'react-bootstrap';
import { css } from 'glamor';
import { Link } from 'react-router';

// import SearchInput from '~/components/global/SearchInput';
import SocialBar from '~/components/global/SocialBar';

const header = css({
    '@media(min-width: 769px)': {
        minHeight: '150px',
        position: 'relative',
        background: 'url("/assets/images/supaback.png") no-repeat',
        backgroundPosition: 'right',
        backgroundSize: 'contain',
        backgroundColor: 'rgb(51, 51, 51)',
    },

    '@media(max-width: 768px)': {
        display: 'none',
    },
});

const logoBlock = css({
    float: 'left',
});

const logo = css({
    width: '400px',
    height: '150px',
});

const social = css({
    textAlign: 'center',
    lineHeight: '150px',
    float: 'right',
});

@observer
export default class Header extends Component {
    render() {
        return (
            <div { ...header }>
                <Grid>
                    <div { ...logoBlock }>
                        <Link to="/">
                            <img { ...logo } src="/assets/images/logo.svg" />
                        </Link>
                    </div>
                    {/* <form className="form-horizontal" role="form">
                        <div className="form-group"> */}

                    {/* TODO implement SEARCH */}
                    {/* <div styleName='search-input'>
                                <SearchInput
                                    placeholder='Game, platform, review...'
                                    icon
                                />
                            </div> */}
                    {/* </div>
                    </form> */}
                    <div { ...social }>
                        <SocialBar />
                    </div>
                </Grid>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/Header/index.js